import { useContext, createContext } from 'react';

export const MeterContext = createContext(null);

export function useMeterContext() {
  return useContext(MeterContext);
}

export default MeterContext;
